import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import ImageMedium from './ImageMedium';
import TextMedium from './TextMedium';
import VideoMedium from './VideoMedium';
import useEntity from './hooks/useEntity';
import ExternalMedium from './ExternalMedium';

const AudioMedium = dynamic(import('./audio-medium/AudioMedium'), { ssr: false });

export const calculateAspectRatio = ({ width, height, maxWidth = NaN, maxHeight = NaN }) => {
  const ratios = [maxWidth / width, maxHeight / height].filter(n => !Number.isNaN(n));

  const ratio = Math.min(...ratios);

  return { width: width * ratio, height: height * ratio };
};

export const getEntityPageListMediumSize = ({ medium, windowWidth, maxHeight } = {}) => {
  const { height, width } = medium;
  const maxWidth = Math.min(600, windowWidth);
  return calculateAspectRatio({ height, width, maxWidth, maxHeight });
};

const PageMedium = ({ id, type, captionTextId, captionAudioId, isCarousel }) => {
  const medium = useEntity({ id, type });
  const [height, setHeight] = useState(null);

  useEffect(() => {
    const windowWidth = window.innerWidth;
    const { height: mediumHeight } = getEntityPageListMediumSize({
      medium,
      windowWidth,
      maxHeight: isCarousel ? '400' : NaN,
    });
    setHeight(mediumHeight);
  }, []);

  if (type === 'texts') return <TextMedium medium={medium} />;
  if (type === 'audios') return <AudioMedium medium={medium} />;

  if (type === 'external-media')
    return <ExternalMedium medium={medium} height={height} isCarousel={isCarousel} />;

  if (!height) return false;

  if (type === 'images')
    return (
      <ImageMedium
        medium={medium}
        height={height}
        captionAudioId={captionAudioId}
        captionTextId={captionTextId}
        isCarousel={isCarousel}
      />
    );
  if (type === 'videos')
    return <VideoMedium medium={medium} height={height} captionTextId={captionTextId} />;

  return medium.id;
};

PageMedium.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  captionTextId: PropTypes.string,
  captionAudioId: PropTypes.string,
  isCarousel: PropTypes.bool,
};

export default PageMedium;
